/**
 * CalendarFirstTimeHelp — Bandeau or affiché 1× sur CalendarScreen pour
 * expliquer la feature aux nouveaux utilisateurs.
 *
 * Dismissible avec persistance AsyncStorage (CalendarAgentService).
 *
 * v1.12.233
 */

import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { dismissFirstTimeHelp } from '../services/CalendarAgentService';
import { useI18n } from '../i18n';

// v1.12.276 — Bannière onboarding 100% i18n. Le service backend renvoie du
// texte FR figé : on l'ignore et on affiche les traductions locales.
const I18N_BENEFITS = [
  'calendar_benefit_avoid_repetitions',
  'calendar_benefit_personal_stats',
  'calendar_benefit_history_inspiration',
  'calendar_benefit_weather_sync',
];

export default function CalendarFirstTimeHelp({ banner, userId, onDismiss }) {
  const { t } = useI18n();
  if (!banner) return null;
  const handleDismiss = async () => {
    if (banner.persist_dismiss) {
      await dismissFirstTimeHelp({ userId });
    }
    onDismiss && onDismiss();
  };
  return (
    <View style={s.card}>
      <Text style={s.title}>{t('first_time_here')}</Text>
      <Text style={s.desc}>{t('calendar_onboarding_desc')}</Text>
      <View style={s.benefits}>
        {I18N_BENEFITS.map((key, i) => (
          <Text key={i} style={s.benefit}>{t(key)}</Text>
        ))}
      </View>
      {banner.dismissible !== false && (
        <TouchableOpacity style={s.cta} activeOpacity={0.85} onPress={handleDismiss}>
          <Text style={s.ctaTxt}>{t('understood_cta')}</Text>
        </TouchableOpacity>
      )}
    </View>
  );
}

const s = StyleSheet.create({
  card: {
    margin: 12,
    padding: 14,
    backgroundColor: '#FBF7EE',
    borderWidth: 1, borderColor: 'rgba(212,175,114,0.45)',
    borderRadius: 14,
    shadowColor: '#9B7B5A', shadowOpacity: 0.08, shadowRadius: 6, shadowOffset: { width: 0, height: 2 },
    elevation: 1,
  },
  title:    { fontSize: 14, fontWeight: '700', color: '#1A1814', marginBottom: 4 },
  desc:     { fontSize: 12, color: '#5F584F', lineHeight: 18, marginBottom: 8 },
  benefits: { gap: 3, marginBottom: 12 },
  benefit:  { fontSize: 12, color: '#1A1814', lineHeight: 17 },
  cta: {
    alignSelf: 'flex-start',
    paddingHorizontal: 14, paddingVertical: 8,
    backgroundColor: '#1A1814',
    borderRadius: 100,
  },
  ctaTxt:   { fontSize: 11, color: '#FFFFFF', fontWeight: '700', letterSpacing: 0.8 },
});
